<template>
    <div
        class="grid grid-cols-12 gap-4 pl-0 items-center justify-between relative mb-4"
    >
        <div class="col-span-12 grid grid-cols-12 gap-4 items-center">
            <div class="md:mb-4 sm:mb-0 col-span-12 md:col-span-6">
                <a
                    href="#"
                    @click.prevent="back()"
                    class="cursor-pointer text-orange hover:text-orange-400 text-sm lg:px-2 rounded-full inline-flex hover:bg-gray-100 outline-none items-center"
                >
                    <i
                        class="fa-light fa-arrow-left-long fa-fw text-base lg:text-xl fa-angle-right mr-3 lg:mr-5 inline"
                    ></i>
                    {{ backLabel }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { useHotelsStore } from '@/store/hotels';
import { useAppStore } from '@/store/app';
import { useRouter, useRoute } from 'vue-router';
import { computed } from 'vue';
export default {
    emits: ['goBack'],
    setup(_, { emit }) {
        const router = useRouter();
        const hotelsStore = useHotelsStore();
        const appStore = useAppStore();
        const currentRoute = useRoute();
        const previousRoute = computed(() => appStore.previousRoute);
        const currentRouteName = computed(() => currentRoute.name);

        const backLabel = computed(() => {
            if (
                !previousRoute.value ||
                previousRoute.value.fullPath === currentRoute.path ||
                !previousRoute.value.name
            ) {
                return 'Go back';
            }
            switch (previousRoute.value.name) {
                case 'HotelProperty':
                    let name = new DOMParser().parseFromString(
                        hotelsStore.property.name,
                        'text/html'
                    ).documentElement.textContent;
                    return `Back to ${name}`;
                case 'Hotels':
                    return 'Back to Hotels Home';
                case 'HotelSearch':
                    return 'Back to Search Results';
                default:
                    return `Back to ${previousRoute.value.name}`;
            }
        });

        const back = () => {
            emit('goBack');

            if (
                currentRouteName.value === 'HotelProperty' &&
                !window.history.state.back
            ) {
                router.push({ name: 'Hotels' });
                return;
            }

            router.back();
        };

        return { back, backLabel };
    },
};
</script>
